module.exports = __webpack_public_path__ + "static/img/fb.9930cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fb.png
// module id = Y3Bk
// module chunks = 1